import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { Brain, Search, Users, Shield, GitBranch, Tag } from 'lucide-react';

const HomePage = () => {
  const { isAuthenticated } = useAuth();

  const features = [
    {
           icon: <Brain size={32} />,
           title: 'KI-Prompt-Verwaltung',
           description: 'Erstelle, organisiere und verwalte deine KI-Prompts mit leistungsstarken Versionsverwaltungs- und Kollaborationsfunktionen.'
         },
         {
           icon: <Search size={32} />,
           title: 'Erweiterte Suche',
           description: 'Finde den perfekten Prompt mit unserem intelligenten Such- und Filtersystem.'
         },
         {
           icon: <Users size={32} />,
           title: 'Teamzusammenarbeit',
           description: 'Teile Prompts mit deinem Team und arbeite gemeinsam an der Prompt-Entwicklung.'
         },
         {
           icon: <Shield size={32} />,
           title: 'Rollenbasierter Zugriff',
           description: 'Sichere Zugriffskontrolle mit Administrator-, Benutzer- und Betrachterrollen.'
         },
         {
           icon: <GitBranch size={32} />,
           title: 'Versionskontrolle',
           description: 'Verfolge Änderungen und pflege die Prompt-Historie mit vollständiger Versionsunterstützung.'
         },
         {
           icon: <Tag size={32} />,
           title: 'Intelligente Verschlagwortung',
           description: 'Organisiere Prompts mit benutzerdefinierten Tags und Kategorien für eine einfache Auffindbarkeit.'
         }
       ];
     
       return (
         <div>
           {/* Hero Section */}
           <section className="py-5 bg-primary text-white">
             <Container>
               <Row className="align-items-center">
                 <Col lg={6} className="mb-4 mb-lg-0">
                   <h1 className="display-4 fw-bold mb-4">
                     Social Value KI-Prompt-Bibliothek
                   </h1>
                   <p className="lead mb-4">
                     Organisiere, versioniere und teile deine KI-Prompts mit leistungsstarken Kollaborationstools.
                   </p>
                   <div className="d-flex gap-3">
                     {isAuthenticated ? (
                       <Button as={Link} to="/dashboard" variant="light" size="lg">
                         Zum Dashboard
                       </Button>
                     ) : (
                       <Button as={Link} to="/login" variant="light" size="lg">
                         <i className="fab fa-google me-2"></i>
                         Loslegen
                       </Button>
                     )}
                   </div>
                 </Col>
                 <Col lg={6} className="text-center">
                   <div className="bg-white bg-opacity-10 rounded-3 p-4">
                     <Brain size={300} className="text-white" />
                   </div>
                 </Col>
               </Row>
             </Container>
           </section>
     
           {/* Features Section */}
           <section className="py-5">
             <Container>
               <Row className="text-center mb-5">
                 <Col>
                   <h2 className="display-6 fw-bold mb-3">Warum PromptHub wählen?</h2>
                   <p className="lead text-muted">
                     Alles, was du zur effektiven Verwaltung deiner KI-Prompts benötigst
                   </p>
                 </Col>
               </Row>
     
               <Row>
                 {features.map((feature, index) => (
                   <Col md={6} lg={4} key={index} className="mb-4">
                     <Card className="h-100 border-0 shadow-sm hover-lift">
                       <Card.Body className="text-center p-4">
                         <div className="text-primary mb-3">
                           {feature.icon}
                         </div>
                         <Card.Title className="h5 mb-3">{feature.title}</Card.Title>
                         <Card.Text className="text-muted">
                           {feature.description}
                         </Card.Text>
                       </Card.Body>
                     </Card>
                   </Col>
                 ))}
               </Row>
             </Container>
           </section>
     
           {/* CTA Section */}
           <section className="py-5" data-bs-theme="dark">
             <Container>
               <Row className="text-center">
                 <Col>
                   <h2 className="display-6 fw-bold mb-3">Bereit loszulegen?</h2>
                   <p className="lead text-muted mb-4">
                     Schließ dich <span className="text-decoration-line-through">Tausenden</span> mehr als einem Dutzend von KI-Praktikern an, die PromptHub für ihre Prompt-Verwaltung vertrauen.
                   </p>
                   {!isAuthenticated && (
                     <Button as={Link} to="/login" variant="primary" size="lg">
                       <i className="fab fa-google me-2"></i>
                       Mit Google anmelden
                     </Button>
                   )}
                 </Col>
               </Row>
             </Container>
           </section>
         </div>
       );
     };
     
     export default HomePage;